// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__IeNcU","errorLogs":"EditorFooter_errorLogs__37erO"};